import { addDoc, collection, serverTimestamp } from 'firebase/firestore';

import { FIREBASE_CONFIG } from '../config/Config';
import { db } from '../shared/api/firebase/config';
import { FS } from '../shared/constants/firestorePaths';

const appId = String(FIREBASE_CONFIG?.projectId || '').trim();

const getStorage = (scope) => {
  if (typeof window === 'undefined') return null;
  try {
    return scope === 'local' ? window.localStorage : window.sessionStorage;
  } catch {
    return null;
  }
};

const buildMarkerKey = ({ clientId, type, dedupeKey }) => {
  return ['rda_portal_event', String(clientId || '').trim(), String(type || '').trim(), String(dedupeKey || 'default').trim()]
    .filter(Boolean)
    .join(':');
};

// [PREVIEW-GUARD] Detecta modo Preview Admin via sinal global setado pelo PortalContext.
// Quando ativo, suprime totalmente a gravação no Firestore para não poluir o
// prontuário real do cliente com eventos falsos do admin testando.
const isPreviewMode = () => {
  if (typeof window === 'undefined') return false;
  try { return Boolean(window.__rda_portal_preview_mode); } catch { return false; }
};

export const logClientPortalEvent = async ({ clientId, type, actorName, category = 'USER', payload = {}, isBot = false }) => {
  const safeClientId = String(clientId || '').trim();
  const safeType = String(type || '').trim();
  if (!safeClientId || !safeType || !appId) return false;

  if (isPreviewMode()) {
    try { console.info('[portalEventLog] Suprimido em Preview Admin:', safeType, safeClientId); } catch { void 0; }
    return false;
  }

  await addDoc(collection(db, ...FS.clientNotes(appId, safeClientId)), {
    category: String(category || 'USER').trim().toUpperCase() === 'SYSTEM' ? 'SYSTEM' : 'USER',
    type: safeType,
    actor: {
      name: String(actorName || '').trim() || 'Cliente',
      isBot: Boolean(isBot),
    },
    payload: payload && typeof payload === 'object' ? payload : {},
    createdAt: serverTimestamp(),
  });

  return true;
};

export const logClientPortalEventOnce = async ({ clientId, type, actorName, category = 'USER', payload = {}, isBot = false, storage = 'session', dedupeKey = 'default' }) => {
  const safeClientId = String(clientId || '').trim();
  const safeType = String(type || '').trim();
  if (!safeClientId || !safeType) return false;

  const store = getStorage(storage);
  const markerKey = buildMarkerKey({ clientId: safeClientId, type: safeType, dedupeKey });

  try {
    if (store && store.getItem(markerKey) === '1') return false;
  } catch {
  }

  const wrote = await logClientPortalEvent({
    clientId: safeClientId,
    type: safeType,
    actorName,
    category,
    payload,
    isBot,
  });

  if (!wrote) return false;

  try {
    if (store) store.setItem(markerKey, '1');
  } catch {
  }

  return true;
};

export const getPortalDayKey = () => {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};
